<template>
  <div
    class="bg-ontick-carbon-900 fixed inset-0 z-40 flex items-center justify-center bg-opacity-60"
    @click.self="$emit('close')"
  >
    <div class="bg-ontick-graphite-500 relative flex w-[814px] flex-col rounded-[32px] p-6">
      <div class="flex items-center justify-between pb-4">
        <p class="text-2xl font-semibold">Detalhes</p>
        <button class="bg-ontick-carbon-600 hover:bg-ontick-carbon-800 p-2 rounded-full" @click="$emit('close')">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.244078 0.244078C0.569515 -0.0813592 1.09715 -0.0813592 1.42259 0.244078L5 3.82149L8.57741 0.244078C8.90285 -0.0813592 9.43049 -0.0813592 9.75592 0.244078C10.0814 0.569515 10.0814 1.09715 9.75592 1.42259L6.17851 5L9.75592 8.57741C10.0814 8.90285 10.0814 9.43049 9.75592 9.75592C9.43049 10.0814 8.90285 10.0814 8.57741 9.75592L5 6.17851L1.42259 9.75592C1.09715 10.0814 0.569515 10.0814 0.244078 9.75592C-0.0813592 9.43049 -0.0813592 8.90285 0.244078 8.57741L3.82149 5L0.244078 1.42259C-0.0813592 1.09715 -0.0813592 0.569515 0.244078 0.244078Z"
              fill="#9CA3AF"
            />
          </svg>
        </button>
      </div>

      <div :class="['grid gap-12 pb-4', album.length ? 'grid-cols-2 pt-2' : 'grid-cols-1']">
        <div v-if="album.length">
          <img
            v-for="(photo, pos) in album"
            v-show="pos === photoCurrent"
            :key="pos"
            :src="photo"
            alt=""
            class="cursor-pointer w-full h-[160px] object-center rounded overflow-hidden"
            @click="showPreview = true"
          />

          <!-- ============================== -->
          <!-- ============================== -->
          <!-- ============================== -->
          <div class="flex items-center justify-center gap-4 pt-3">
            <button
              class="cursor-pointer bg-ontick-steel-500 hover:bg-ontick-steel-600 rounded-full w-[24px] h-[24px] flex items-center justify-center"
              style="box-shadow: 0 1px 2px 0 #000"
              @click="previous"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.20679 0.293081C6.39426 0.480609 6.49957 0.734916 6.49957 1.00008C6.49957 1.26525 6.39426 1.51955 6.20679 1.70708L2.91379 5.00008L6.20679 8.29308C6.38894 8.48168 6.48974 8.73429 6.48746 8.99648C6.48518 9.25868 6.38001 9.50949 6.1946 9.6949C6.0092 9.88031 5.75838 9.98548 5.49619 9.98775C5.23399 9.99003 4.98139 9.88924 4.79279 9.70708L0.792786 5.70708C0.605315 5.51955 0.5 5.26525 0.5 5.00008C0.5 4.73492 0.605315 4.48061 0.792786 4.29308L4.79279 0.293081C4.98031 0.10561 5.23462 0.000294478 5.49979 0.000294467C5.76495 0.000294455 6.01926 0.10561 6.20679 0.293081Z"
                  fill="#D4D4D4"
                />
              </svg>
            </button>

            <div class="flex items-center justify-center gap-2">
              <button
                v-for="i in album.length"
                :key="i"
                :class="[
                  'w-[8px] h-[8px] rounded-full transition-all duration-300 ease-in-out',
                  {
                    'bg-ontick-blue-500': photoCurrent === i - 1,
                    'bg-ontick-steel-400': photoCurrent !== i - 1,
                  },
                ]"
                style="box-shadow: 0 1px 2px 0 #000"
                @click="photoCurrent = i - 1"
              >
                &nbsp;
              </button>
            </div>

            <button
              class="cursor-pointer bg-ontick-steel-500 hover:bg-ontick-steel-600 rounded-full w-[24px] h-[24px] flex items-center justify-center"
              style="box-shadow: 0 1px 2px 0 #000"
              @click="next"
            >
              <svg
                class="rotate-180"
                xmlns="http://www.w3.org/2000/svg"
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.20679 0.293081C6.39426 0.480609 6.49957 0.734916 6.49957 1.00008C6.49957 1.26525 6.39426 1.51955 6.20679 1.70708L2.91379 5.00008L6.20679 8.29308C6.38894 8.48168 6.48974 8.73429 6.48746 8.99648C6.48518 9.25868 6.38001 9.50949 6.1946 9.6949C6.0092 9.88031 5.75838 9.98548 5.49619 9.98775C5.23399 9.99003 4.98139 9.88924 4.79279 9.70708L0.792786 5.70708C0.605315 5.51955 0.5 5.26525 0.5 5.00008C0.5 4.73492 0.605315 4.48061 0.792786 4.29308L4.79279 0.293081C4.98031 0.10561 5.23462 0.000294478 5.49979 0.000294467C5.76495 0.000294455 6.01926 0.10561 6.20679 0.293081Z"
                  fill="#D4D4D4"
                />
              </svg>
            </button>
          </div>
          <!-- ============================== -->
          <!-- ============================== -->
          <!-- ============================== -->
        </div>
        <dl class="space-y-1">
          <dt>Comentário</dt>
          <dd class="!font-normal !text-gray-50">
            {{ tradeIdea.ti_comment || "Nenhum comentário adicionado." }}
          </dd>
        </dl>
      </div>

      <div class="grid grid-cols-5 gap-3 py-4 border-t-2 border-t-ontick-steel-500">
        <dl class="space-y-1">
          <dt>Operação</dt>
          <dd>
            <div class="flex flex-col items-start gap-1">
              <div class="flex items-center gap-2">
                <!-- Ativo -->
                <span
                  class="text-xs font-medium bg-ontick-blue-900 rounded-sm flex items-center justify-center w-[54px] h-5"
                >
                  {{ tradeIdea.ti_symbol }}
                </span>

                <!-- Compra (C) / Venda (V) -->
                <span
                  v-tippy="{ theme: 'ontick', arrow: true }"
                  :content="tradeIdea.ti_direction === 'BUY' ? 'Compra' : 'Venda'"
                  class="w-5 h-5 flex items-center justify-center rounded-sm bg-ontick-yellow-800 text-ontick-graphite-500 text-xs font-bold"
                >
                  {{ tradeIdea.ti_direction === "BUY" ? "C" : "V" }}
                </span>
              </div>
            </div>
          </dd>
        </dl>

        <dl>
          <dt>Status</dt>
          {{ tradeIdeasTypes.status(tradeIdea.ti_status) }}
        </dl>

        <dl>
          <dt>Tipo</dt>
          <dd>
            <span v-if="tradeIdea.ti_style === 'SWING_TRADE'">Swing trade</span>
            <span v-if="tradeIdea.ti_style === 'DAY_TRADE'">Day trade</span>
          </dd>
        </dl>

        <dl>
          <dt>Início</dt>
          <dd>
            {{ moment(tradeIdea.ti_start_datetime).format("DD/MM/YYYY") }}
          </dd>
        </dl>

        <dl>
          <dt>Analista técnico</dt>
          <dd>
            <p>{{ tradeIdea.strategy_analyst }}</p>
            <!-- <p class="text-xs font-normal">CNPI-T EM 123</p> -->
          </dd>
        </dl>

        <dl>
          <dt>Entrada</dt>
          <dd>{{ tradeIdea.to_info.to_entry_price | currency }}</dd>
        </dl>

        <dl>
          <dt>TP</dt>
          <dd>{{ tradeIdea.ti_take_profit_price | currency }}</dd>
        </dl>

        <dl>
          <dt>SL</dt>
          <dd>{{ tradeIdea.ti_stop_loss_price | currency }}</dd>
        </dl>

        <dl>
          <dt>RP</dt>
          <dd>
            <span class="text-gray-500 text-sm font-semibold">-</span>
          </dd>
        </dl>

        <dl>
          <dt>BE</dt>
          <dd>
            <span class="text-gray-500 text-sm font-semibold">-</span>
          </dd>
        </dl>
      </div>

      <div class="grid grid-cols-4 gap-3">
        <dl>
          <dt>Financeiro alocado</dt>
          <dd>
            <span v-tippy="{ theme: 'ontick', arrow: true }" :content="tradeIdea.to_info.to_allocated_value">{{
              tradeIdea.to_info.to_allocated_value | currency
            }}</span>
            <span
              v-tippy="{ theme: 'ontick', arrow: true }"
              :content="tradeIdea.to_info.to_allocated_percent"
              class="text-gray-500"
              >&nbsp;({{ Number(tradeIdea.to_info.to_allocated_percent).toLocaleString("pt-BR") }}%)</span
            >
          </dd>
        </dl>

        <dl>
          <dt>Resultado</dt>
          <dd>
            <div v-if="tradeIdea.to_info.to_pnl != null" class="flex items-center gap-2">
              <i v-html="$icons.play_green" v-if="tradeIdea.to_info.to_pnl > 0"></i>
              <i v-html="$icons.play_red" v-else-if="tradeIdea.to_info.to_pnl < 0"></i>
              <i v-else>
                <div class="h-3 w-3 rounded-full bg-gray-500"></div>
              </i>
              <span
                v-tippy="{ theme: 'ontick', arrow: true }"
                :content="tradeIdea.to_info.to_pnl"
                class="text-gray-300"
                >{{ tradeIdea.to_info.to_pnl | currency }}</span
              >
            </div>
            <span v-else class="text-gray-500 text-sm font-semibold">-</span>
          </dd>
        </dl>
      </div>
    </div>

    <portal to="modal">
      <transition name="fade">
        <div
          v-if="showPreview"
          class="bg-ontick-carbon-900 fixed inset-0 z-50 flex items-center justify-center bg-opacity-60"
          @click.self="showPreview = false"
        >
          <div class="bg-transparent relative flex h-full max-h-[75%] flex-col rounded-[32px] overflow-hidden">
            <button
              class="absolute top-3 right-6 cursor-pointer bg-ontick-carbon-500 p-2 rounded-full"
              style="box-shadow: 0 1px 2px 0 #000"
              @click="showPreview = false"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.244078 0.244078C0.569515 -0.0813592 1.09715 -0.0813592 1.42259 0.244078L5 3.82149L8.57741 0.244078C8.90285 -0.0813592 9.43049 -0.0813592 9.75592 0.244078C10.0814 0.569515 10.0814 1.09715 9.75592 1.42259L6.17851 5L9.75592 8.57741C10.0814 8.90285 10.0814 9.43049 9.75592 9.75592C9.43049 10.0814 8.90285 10.0814 8.57741 9.75592L5 6.17851L1.42259 9.75592C1.09715 10.0814 0.569515 10.0814 0.244078 9.75592C-0.0813592 9.43049 -0.0813592 8.90285 0.244078 8.57741L3.82149 5L0.244078 1.42259C-0.0813592 1.09715 -0.0813592 0.569515 0.244078 0.244078Z"
                  fill="#07A4FF"
                />
              </svg>
            </button>
            <img :src="album[photoCurrent]" alt="" class="w-full h-full object-contain" />
          </div>
        </div>
      </transition>
    </portal>
  </div>
</template>

<script>
import { tradeIdeasTypes } from "../utils-trade-ideas";

export default {
  name: "ModalDetails",

  props: {
    tradeIdea: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      tradeIdeasTypes,
      pnl: 500,
      album: [],
      photoCurrent: 0,
      showPreview: false,
    };
  },

  methods: {
    previous() {
      if (this.photoCurrent > 0) {
        this.photoCurrent--;
      } else {
        this.photoCurrent = this.album.length - 1;
      }
    },

    next() {
      if (this.photoCurrent < this.album.length - 1) {
        this.photoCurrent++;
      } else {
        this.photoCurrent = 0;
      }
    },

    closePhoto() {
      this.showPreview = false;
    },
  },

  mounted() {
    if (this.tradeIdea && this.tradeIdea.ti_images) {
      this.album = this.tradeIdea.ti_images;
    } else {
      // TESTE TEMPORÁRIO
      // this.album = [
      //   "https://fastly.picsum.photos/id/1084/536/354.jpg?grayscale&hmac=Ux7nzg19e1q35mlUVZjhCLxqkR30cC-CarVg-nlIf60",
      //   "https://fastly.picsum.photos/id/234/536/354.jpg?hmac=xwmMcTiZqMLkn5gOMUyoMQTnrYfX8RrhBpyOpOrIFCE",
      //   "https://fastly.picsum.photos/id/237/536/354.jpg?hmac=i0yVXW1ORpyCZpQ-CknuyV-jbtU7_x9EBQVhvT5aRr0",
      // ];
    }
  },
};
</script>

<style lang="scss" scoped>
dl {
  @apply py-1;
  dt {
    @apply text-gray-400 text-base font-normal;
  }
  dd {
    @apply text-base font-medium text-gray-300;
  }
}

.fade {
  &-enter,
  &-leave-to {
    @apply scale-125 opacity-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-300 ease-in-out;
  }
}
</style>
